/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-07-22 16:16:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-09-24 10:16:04
 * @FilePath: \mrc-base-server-view\src\mixin\national.js
 */
import { btnPermissionList } from '@/service/api/btnPermission'
export default {
    data() {
        return {

        }
    },
    methods: {
        async getBtnPermissionList() {
            const res = await btnPermissionList({
                function_uuid: this.$store.getters.menuFunctionUuid
            })
            this.$store.commit('setBtnPermission', res.data ? res.data : [])
        },
        hasBtn(name) {
            let btnName = Object.prototype.toString.call('name').indexOf('String') > -1 ? [name] : name
            const btnPermission = this.$store.state.btnPermission || []
            return btnName.some(item => btnPermission.includes(item))
        }
    }
}